











































































import Vue from "vue";
import VaCard from "@/components/molecules/VaCard.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import FileUtil from "@/utils/fileUtil";
import { ReleaseNotes } from "@/models/releaseNotes";

export default Vue.extend({
  name: "TrialStepDownloadWindows",
  components: { VaCard, VaButton },
  data() {
    return {
      downloading: false,
    };
  },
  computed: {
    roomStable(): ReleaseNotes | undefined {
      const notes: ReleaseNotes[] = this.$store.getters["cms/releaseNotes"];
      return notes.find(
        (note) =>
          !note.fastChannel && note.product === "room" && note.os === "windows"
      );
    },
    controllerIos(): ReleaseNotes | undefined {
      const notes: ReleaseNotes[] = this.$store.getters["cms/releaseNotes"];
      return notes.find(
        (note) => note.product === "controller" && note.os === "ios"
      );
    },
    controllerAndroid(): ReleaseNotes | undefined {
      const notes: ReleaseNotes[] = this.$store.getters["cms/releaseNotes"];
      return notes.find(
        (note) => note.product === "controller" && note.os === "android"
      );
    },
  },
  async created() {
    this.$store.dispatch("cms/fetchReleaseNotes");
  },
  methods: {
    downloadExe() {
      this.downloading = true;
      try {
        const url = this.roomStable?.url;
        if (url) FileUtil.download(url);
      } finally {
        this.downloading = false;
      }
    },
  },
});
